export default __webpack_public_path__ + "0bd072992e6c4987f76d29556dc65db5.svg";